import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import ReactPixel from 'react-facebook-pixel'

const pixelId = '619527674304487'

// Initialize Meta Pixel
ReactPixel.init(pixelId)
ReactPixel.pageView() // Initial page load

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
